import React, { useState } from "react";
import { Button, Grid, Box, InputLabel, OutlinedInput, InputAdornment, IconButton } from "@mui/material";
import { Controller, FormProvider, useForm } from "react-hook-form";
import { useParams, useNavigate, Link } from "react-router-dom";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { confirmPasswordReset } from "../../API/AuthLayer";
import { notify } from "../Common";
import { ReactComponent as Spinner_2 } from "../../Assets/Spinner_2.svg";
import "./Login.css";

export default function PasswordResetConfirm() {
  const { token } = useParams(); // Extract secure token string directly from URL path syntax
  const navigate = useNavigate();
  const methods = useForm();
  const { handleSubmit, control, formState: { errors } } = methods;
  
  const [showPassword, setShowPassword] = useState(false);
  const [apiLoading, setApiLoading] = useState(false);

  const onSubmit = (data) => {
    setApiLoading(true);
    confirmPasswordReset(token, data.password)
      .then((res) => {
        setApiLoading(false);

        // 1. Detect if the user is visiting via a mobile device/browser
        const isMobileUser = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        );

        if (isMobileUser) {
          notify("success", "Password has been changed successfully! Please return to your Mobile App to log in.");
        } else {
          notify("success", "Password updated successfully!");
          navigate("/login", { replace: true });
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        notify("error", "Token missing, expired, or invalid.");
        setApiLoading(false);
      });
  };

  return (
    <div style={{ padding: "auto", margin: "60px 10px 0 10px" }}>
      <Box container sx={{ maxWidth: "412px", margin: "20px auto" , padding: "20px auto" }}>
        <FormProvider {...methods}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <p className="heading" style={{ marginBottom: "8px" }}>Create New Password</p>
            <p style={{ marginBottom: "38px" }}>Please input your custom modified authentication credentials below.</p>

            <Grid item xs={12}>
              <InputLabel sx={{ color: "#303535", margin: "5px 0" }}>Enter New Password *</InputLabel>
              <Controller
                name="password"
                control={control}
                rules={{ required: true, minLength: 8 }}
                render={({ field }) => (
                  <OutlinedInput
                    {...field}
                    fullWidth
                    size="small"
                    type={showPassword ? "text" : "password"}
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    }
                    error={Boolean(errors.password)}
                  />
                )}
              />
              {errors.password && (
                <p style={{ color: "#D32f2f", fontSize: "12px", marginTop: "5px" }}>
                  Password is required and must be at least 8 characters long.
                </p>
              )}
            </Grid>

            <Button
              variant="contained"
              fullWidth
              type="submit"
              sx={{
                textTransform: "capitalize",
                padding: "16px 0 15px 0",
                marginTop: "25px",
                background: "linear-gradient(272.65deg, #383194 0%, #da1e7a 100%)",
                borderRadius: "5px",
                fontWeight: 700,
                fontSize: "16px",
              }}
            >
              Update Password
            </Button>
          </form>
        </FormProvider>
      </Box>

      {apiLoading && (
        <div className="overlay">
          <Spinner_2 style={{ width: "80px" }} />
        </div>
      )}
    </div>
  );
}